export const normalizeActivityId = (value) => {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	const parsedValue = Number(value);
	return Number.isNaN(parsedValue) ? value : parsedValue;
};

export const hasVisibleActivity = (activityId, activityName) => {
	if (normalizeActivityId(activityId) === null) {
		return false;
	}

	if (typeof activityName === 'string') {
		return activityName.trim().length > 0;
	}

	return Boolean(activityName);
};

export const isActivityMatch = (leftActivityId, rightActivityId) => {
	return normalizeActivityId(leftActivityId) === normalizeActivityId(rightActivityId);
};
